import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import CredentialForm from "../partials/account/CredentialForm";
import { useForm, FormContainer, FormErrorProvider } from "react-hook-form-mui";
import { BoxContainer } from "../layouts/Theme";
import { useI18N } from "../context/I18NContext";
export default function Credentials(props) {
    const { t } = useI18N();
    const formContext = useForm({});
    const onSubmit = (data, event) => {
    };
    const onError = (errors) => {
    };
    return (_jsx(BoxContainer, { children: _jsx(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: _jsxs(FormErrorProvider, { onError: (error) => {
                    if (error.type === 'validate') {
                        console.log(error);
                    }
                    return t(error.type, 'error');
                }, children: [_jsx(CredentialForm, { label: "Wijzig je inloggegevens" }), _jsx(Button, { fullWidth: true, sx: { my: 1 }, variant: "contained", children: t('Wachtwoord wijzigen') })] }) }) }));
}
